<main class="d-flex-row flex-wrap main">
    <div class="form-container">
        <pme-payment-form
            *ngIf="(this.cart)"
            [paymentOptions]="this.paymentOptions"
            [termOfUse]="this.termOfUseUrl"
            [discountBadge]="this.discountBadge"
            [retentionBankBilletCart]="this.originalCart"
            [retentionCreditCardCart]="this.retentionCart"
            [automaticRechargeOnly]="this.cart.product.automaticRechargeOnly"
            [creditCardData]="this.creditCardData"
            [creditCardsData]="this.creditCardsData"
            [maxLimitCreditCards]="maxLimitCreditCards"
            [campaignMessage]="this.cart && this.cart.allowSaleWithoutPayment ? this.cart.saleMessageInfo : null"
            [context]="this.context"
            (paymentConditionSelected)="onPaymentConditionSelected($event)"
            (formSubmitted)="onPaymentFormSubmitted($event)"
            (paymentMethodSelected)="onPaymentMethodSelected($event)"
            (deleteCreditCard)="handleDeleteCreditCard($event)"
            [allowAutomaticRecharge]="this.customer.provisioningParameter.allowAutomaticRecharge"
            [newPayment]="true"
            [hiddenAdobeDtm]="this.hiddenAdobeDtm"
            [suggestionMessage] = "this.suggestionMessage"
            [isACreditCardError]="this.isACreditCardError" 
            [adyenCardError] = "this.adyenCardError"
            (selectedOptionInstallmentEmitter) = "this.selectedOptionInstallmentEmitter($event)"
            >
        </pme-payment-form>
    </div>
    <aside class="product-info-card" *ngIf="(this.cart)">
        <pme-disconnected-sale-product 
            [productFamily]="this.productFamily" 
            [productName]="this.productName"
            [valuePerMonth]="this.cart.paymentMethod.identifier === 'CREDIT_CARD' ? this.installmentSelected.installmentValue : this.cart.totalValue" 
            [totalValue]="this.totalValue"
            [productImg]="this.productImg"
            [installments]="this.cart.paymentMethod.identifier === 'CREDIT_CARD' ? this.installmentSelected.installment : 1"
            [firstStep]="false"
            [productValue]="this.productValue"
            [discountedValue]="this.cart.discountedValue || 0"
            (cartUpdated)="this.handleCartUpdate()">
        </pme-disconnected-sale-product>
    </aside>
</main>
